module.exports = __webpack_public_path__ + "fonts/ADTJN28c.woff2";